import { Routes } from '@angular/router';

import { devicesSegments } from '@advania-cosoftware/wolf-router';

export const devicesRoutes: Routes = [
    {
        path: devicesSegments.devices,
        loadComponent: () => import('./pages/devices-tab-page/devices-tab.page').then((m) => m.DevicesTabPage),
        children: [
            {
                path: `${devicesSegments.clients}/:serialNumber`,
                loadComponent: () => import('./pages/clients/client-page/client.page').then((m) => m.ClientPage),
            },
            {
                path: devicesSegments.clients,
                loadComponent: () => import('./pages/clients/clients-page/clients.page').then((m) => m.ClientsPage),
            },
            {
                path: `${devicesSegments.servers}/:serverId`,
                loadComponent: () => import('./pages/servers/server-page/server.page').then((m) => m.ServerPage),
            },
            {
                path: devicesSegments.servers,
                loadComponent: () => import('./pages/servers/servers-page/servers.page').then((m) => m.ServersPage),
            },
            {
                path: `${devicesSegments.mobileDevices}/:serialNumber`,
                loadComponent: () =>
                    import('./pages/mobile-devices/mobile-device-page/mobile-device.page').then(
                        (m) => m.MobileDevicePage,
                    ),
            },
            {
                path: devicesSegments.mobileDevices,
                loadComponent: () =>
                    import('./pages/mobile-devices/mobile-devices-page/mobile-devices.page').then(
                        (m) => m.MobileDevicesPage,
                    ),
            },
        ],
    },
];
